<template>
  <div
    v-cloak
    v-if="template && rules"
    class="item-common pt-10 pb-15 px-7 type-career"
  >
    <div class="header">
      <div class="d-flex">
        <h1 class="title">
          {{ $t('봉사활동') }}
          <span
            v-if="itemMaxLength && $i18n.locale == 'ko'"
            class="max-length-guide"
          >
            최대 {{ itemMaxLength }}개 입력 가능</span
          >
          <span
            v-if="itemMaxLength && $i18n.locale == 'en'"
            class="max-length-guide"
          >
            You can enter Max {{ itemMaxLength }}</span
          >
        </h1>
      </div>
      <v-divider></v-divider>
      <p class="desc" v-html="template.guideVolunteer"></p>
    </div>
    <div class="body">
      <v-form ref="saveForm" v-if="!isReadonly">
        <div class="mt-8" v-if="obj">
          <v-row class="mt-2">
            <v-col
              cols="12"
              :class="{ 'col-md-11': !isReadonly, 'col-md-12': isReadonly }"
            >
              <v-row>
                <v-col cols="12" class="col-md-3" :class="colclass">
                  <i-select
                    :label="itemLabel('volunteerType')"
                    :items="itemArray('volunteerType')"
                    v-model="obj.volunteerType"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[rules.required('volunteerType', true)]"
                    :class="leftRoundedClass"
                  ></i-select>
                </v-col>
                <v-col cols="12" class="col-md-3" :class="colclass">
                  <i-text-field
                    v-model="obj.volunteerOrganization"
                    v-maxlength="'volunteerOrganization'"
                    :label="itemLabel('volunteerOrganization')"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[
                      rules.required('volunteerOrganization', true),
                      rules.maxlength('volunteerOrganization'),
                    ]"
                    :class="leftRoundedClass"
                  ></i-text-field>
                </v-col>
                <v-col cols="12" class="col-md-3" :class="colclass">
                  <i-text-field
                    v-model="obj.volunteerHours"
                    v-maxlength="'volunteerHours'"
                    :label="itemLabel('volunteerHours')"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[
                      rules.required('volunteerHours', true),
                      rules.maxlength('volunteerHours'),
                    ]"
                    :class="leftRoundedClass"
                  ></i-text-field>
                </v-col>
                <v-col cols="12" class="col-md-3" :class="colclass">
                  <i-text-field
                    v-model="obj.volunteerRegion"
                    v-maxlength="'volunteerRegion'"
                    :label="itemLabel('volunteerRegion')"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[
                      rules.required('volunteerRegion', true),
                      rules.maxlength('volunteerRegion'),
                    ]"
                    :class="leftRoundedClass"
                  ></i-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="d-none d-md-block pl-3 col-md-1">
              <i-btn elevation="0" color="primary" block @click="add"
                >저장</i-btn
              >
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col cols="12" class="d-md-none d-block">
              <i-btn elevation="0" color="normal" outlined block @click="add"
                >저장</i-btn
              >
            </v-col>
          </v-row>
        </div>
      </v-form>
      <v-alert v-if="submitErrorAlert" dense outlined type="error">
        {{ submitErrorMessage }}
      </v-alert>
      <v-divider v-if="!isReadonly"></v-divider>
      <v-form ref="updateForm" :readonly="isReadonly">
        <template v-for="(item, i) in volunteers">
          <v-divider :key="'volunteerdiv' + i" v-if="i != 0"></v-divider>
          <div class="mt-8" v-if="item" :key="'volunteer' + i">
            <v-row class="mt-2">
              <v-col
                cols="12"
                :class="{ 'col-md-11': !isReadonly, 'col-md-12': isReadonly }"
              >
                <v-row>
                  <v-col cols="12" class="col-md-3" :class="colclass">
                    <i-select
                      :label="itemLabel('volunteerType')"
                      :items="itemArray('volunteerType')"
                      v-model="item.volunteerType"
                      outlined
                      dense
                      @blur="save(i)"
                      hide-details="auto"
                      :rules="[rules.required('volunteerType', true)]"
                      :class="leftRoundedClass"
                    ></i-select>
                  </v-col>
                  <v-col cols="12" class="col-md-3" :class="colclass">
                    <i-text-field
                      v-model="item.volunteerOrganization"
                      v-maxlength="'volunteerOrganization'"
                      :label="itemLabel('volunteerOrganization')"
                      outlined
                      dense
                      hide-details="auto"
                      :rules="[
                        rules.required('volunteerOrganization'),
                        rules.maxlength('volunteerOrganization'),
                      ]"
                      @blur="save(i)"
                      :class="leftRoundedClass"
                    ></i-text-field>
                  </v-col>
                  <v-col cols="6" class="col-md-3" :class="colclass">
                    <i-text-field
                      v-model="item.volunteerHours"
                      v-maxlength="'volunteerHours'"
                      :label="itemLabel('volunteerHours')"
                      outlined
                      dense
                      hide-details="auto"
                      :rules="[
                        rules.required('volunteerHours', true),
                        rules.maxlength('volunteerHours'),
                      ]"
                      :class="leftRoundedClass"
                    ></i-text-field>
                  </v-col>
                  <v-col cols="6" class="col-md-3" :class="colclass">
                    <i-text-field
                      v-model="item.volunteerRegion"
                      v-maxlength="'volunteerRegion'"
                      :label="itemLabel('volunteerRegion')"
                      outlined
                      dense
                      hide-details="auto"
                      :rules="[
                        rules.required('volunteerRegion', true),
                        rules.maxlength('volunteerRegion'),
                      ]"
                      :class="leftRoundedClass"
                    ></i-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="d-none d-md-block pl-3 col-md-1" v-if="!isReadonly">
                <i-btn
                  elevation="0"
                  color="normal"
                  block
                  outlined
                  @click="remove(i)"
                  >삭제</i-btn
                >
              </v-col>
            </v-row>

            <v-row class="mt-2" v-if="!isReadonly">
              <v-col cols="12" class="d-md-none d-block">
                <i-btn
                  elevation="0"
                  color="normal"
                  block
                  outlined
                  @click="remove(i)"
                  >삭제</i-btn
                >
              </v-col>
            </v-row>
          </div>
        </template>
      </v-form>
    </div>
  </div>
</template>

<script>
import { LoadingMixin } from '@/mixin/loading.js';
import { mdiCalendarBlank } from '@mdi/js';
import { resumeType } from '@/const/resumeType';
import { equals } from '@/utils/util';
import { snack } from '@/plugins/dialog/api';

export default {
  mixins: [LoadingMixin],
  props: {
    template: { type: Object },
    info: { type: Object },
    opts: { type: Object },
    rules: { type: Object },
    dynamicScreenTagClass: { type: Object },
    leftRoundedClass: { type: Object },
    rightRoundedClass: { type: Object },
    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },

  mounted() {
    this.setting();
  },
  computed: {
    itemMaxLength() {
      return +this.opts?.volunteer?.oMaxLength || 0;
    },
    canAdd() {
      return (
        !this.opts?.volunteer?.oMaxLength ||
        this.opts.volunteer?.oMaxLength > this.volunteers.length
      );
    },
    rowclass: function() {
      return {
        'mt-2':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
      };
    },
    colclass: function() {
      return {
        'mt-2':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
    lrzrclass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
        'rounded-l':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
        'rounded-r-0':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
    rrzrclass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
        'rounded-r':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
        'rounded-l-0':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
    zeroRoundedClass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
      };
    },
  },
  data: () => ({
    mdiCalendarBlank,
    itemDelimeter: '#',
    itemSeq: 1,
    obj: null,
    volunteer: '',
    volunteers: [],
    saveAlert: false,
    deleteAlert: false,
    submitErrorAlert: false,
    submitErrorMessage: '',
  }),
  watch: {
    saveAlert: function() {
      if (this.saveAlert) {
        setTimeout(() => {
          this.saveAlert = false;
        }, 2000);
      }
    },
    deleteAlert: function() {
      if (this.deleteAlert) {
        setTimeout(() => {
          this.deleteAlert = false;
        }, 2000);
      }
    },
    submitErrorAlert: function() {
      if (this.submitErrorAlert) {
        setTimeout(() => {
          this.submitErrorAlert = false;
        }, 10000);
      }
    },
  },
  methods: {
    itemLabel: function(key) {
      var label = this.template[key];

      if (this.opts && this.opts.hasOwnProperty(key)) {
        label =
          this.opts[key].oRequireYn === 'Y'
            ? '*' + this.$t(label)
            : this.$t(label);
      }

      return label;
    },
    itemLength: function(key) {
      var length = 0;
      if (this.opts && this.opts.hasOwnProperty(key)) {
        var defaultLength = 2;
        length = this.opts[key].oLength
          ? this.opts[key].oLength
          : defaultLength;
      }
      return length;
    },
    itemArray: function(key) {
      var array = [];

      if (this.opts && this.opts.hasOwnProperty(key)) {
        array = this.opts[key].oItems
          ? this.opts[key].oItems.split(this.itemDelimeter)
          : [];
      }
      return array;
    },
    setting() {
      //DATE VALIDATE RULE SET

      const type = resumeType.typeVolunteer[this.template.typeVolunteer];

      if (type) {
        const items = type;
        this.volunteer = Object.keys(resumeType.typeVolunteer).find(key =>
          equals(items, resumeType.typeVolunteer[key]),
        );
      }

      this.dataSetting();
      this.obj = this.defaultObj();
    },
    dataSetting: function() {
      if (
        this.info &&
        this.info.volunteers &&
        this.info.volunteers.length > 0
      ) {
        console.log('this.info.volunteers[0]', this.info.volunteers[0]);
        this.itemSeq = this.info.volunteers[0].id.seq;
        this.volunteers = [];

        let $this = this;
        console.log('-----------------');
        console.log(this.info);
        this.info.volunteers.forEach(function(v) {
          let obj = {
            ...v,
            seq: v.id.seq,
          };

          $this.volunteers.push(obj);
          $this.itemSeq =
            $this.itemSeq < v.id.seq ? v.id.seq + 1 : $this.itemSeq + 1;
        });
      }
    },
    defaultObj: function() {
      let obj = {
        seq: this.itemSeq++,
        volunteerType: '',
        volunteerOrganization: '',
        volunteerHours: '',
        volunteerRegion: '',
      };
      return obj;
    },
    add: function() {
      if (!this.canAdd && this.$i18n.locale == 'ko')
        return this.$showAlert(
          `${this.template.volunteerTitle} 은(는) 최대 ${this.opts.volunteer.oMaxLength}개 까지 입력 가능 합니다.`,
        );
      else if (!this.canAdd && this.$i18n.locale == 'en')
        return this.$showAlert(
          `MaxSize of ${this.template.volunteerTitle} is ${this.opts.volunteer.oMaxLength}개 까지 입력 가능 합니다.`,
        );
      if (this.$refs.saveForm.validate()) {
        this.save(-1);
      }
    },
    remove: function(i) {
      this.delete(i);
    },

    valid: function() {
      //필수 여부 체크
      if (
        this.opts &&
        this.opts.volunteer &&
        this.opts.volunteer.oRequireYn &&
        this.opts.volunteer.oRequireYn == 'Y' &&
        this.volunteers.length < 1
      ) {
        this.submitErrorMessage = this.$t(
          '최소 1개의 정보는 존재하여야 합니다.',
        );
        this.submitErrorAlert = true;
        return false;
      }

      return this.$refs.updateForm.validate();
    },
    async save(i) {
      await this.$nextTick();
      console.log('this.obj', this.obj);
      console.log('this.schoolActivitys', this.volunteers);
      var item = i === -1 ? this.obj : this.volunteers[i];
      if (!this.$refs[i === -1 ? 'saveForm' : 'updateForm'].validate()) return;
      const id = {
        annoId: this.$route.params.annoId,
        seq: item.seq,
      };

      const p = {
        id,
        ...Object.keys(item).reduce((a, key) => {
          /** @type {string} */
          if (key.startsWith('volunteer')) a[key] = item[key];
          return a;
        }, {}),
      };

      console.log('p', p);
      console.log('i', i);
      this.$emit('save', p, 'volunteer', i);
    },
    savecallback: function(res, i) {
      if (res.status !== 200) {
        console.log('SCHOOLACT SAVE FAIL');
      } else snack.info(`저장되었습니다.`);
      //SAVE FORM
      if (i === -1) {
        this.volunteers.push(this.obj);
        this.obj = this.defaultObj();
        this.$refs.saveForm.resetValidation();
      }
    },
    delete: function(i) {
      this.showLoading();
      const p = {
        annoId: this.$route.params.annoId,
        seq: this.volunteers[i].seq,
      };

      this.$emit('delete', p, 'volunteer', i);
    },
    deletecallback: function(res, i) {
      if (res.status !== 200) {
        console.log('SCHOOLACT DELETE FAIL');
      } else {
        snack.danger(`삭제되었습니다.`);
        this.volunteers.splice(i, 1);
      }
      this.hideLoading();
    },
  },
};
</script>

<style>
.v-parallax {
  height: 100% !important;
}
.guide-common {
  min-height: calc(100vh - 64px - 122px);
}

.item-common .header .title {
  font-size: 18px;
  font-weight: bold;
  line-height: 2.67;
  letter-spacing: -0.36px;
  color: #292929;
}
.item-common .header .desc {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.28px;
  color: #555555;
}
.item-common .body {
  margin-top: 22px;
}
.item-common .body .v-divider {
  margin-top: 20px;
  margin-bottom: 20px;
}

.item-common .row {
  margin: 0px;
}
.item-common .col {
  padding: 0px;
}
.item-common .i-text-field {
  min-height: 36px;
}
.btn-post-wrap {
  position: relative;
}
.btn-post {
  position: absolute;
  top: 6px;
  right: 5px;
}

.type-career .sub-title-standard {
  position: relative;
}
.type-career .sub-title-standard .v-input__slot {
  padding-left: 100px !important;
}
.type-career .sub-title-standard .sub-title {
  position: absolute;
  left: 10px;
  top: 10px;
  font-size: 14px;
  font-weight: 700;
  color: #363c43;
}
</style>
